export default "__VITE_ASSET__ffc74ce9__"